import OrdersMapModal from "@/Components/Modal/OrdersMapModal";
import PrinterSettingModal from "@/Components/Modal/PrinterSettingModal";
import useLiveModal from "@/shared/atoms/useLiveModal";
import { modalNameEnum } from ".";
import TimeModal from "@/Components/Order/TimeModal";
import useLiveOrder from "@/shared/atoms/useLiveOrder";
import useUserSettingsQuery from "@/shared/queries/user/useUserSettingsQuery";

const LiveModals = () => {
  const [modalName, setModalName] = useLiveModal();
  const [order] = useLiveOrder();
  const { data: settings } = useUserSettingsQuery();

  return (
    <>
      {modalName === modalNameEnum.ORDER_MAP && (
        <OrdersMapModal show={true} onExit={() => setModalName(null)} />
      )}
      {modalName === modalNameEnum.PRINTER_SETTINGS_MODAL && (
        <PrinterSettingModal show={true} onExit={() => setModalName(null)} />
      )}
      {modalName === modalNameEnum.TIME_MODAL && (
        <TimeModal
          onExit={() => {
            setModalName(null);
          }}
          onApproveFinish={() => {
            setModalName(null);
          }}
          order={order}
          isOrderConfirmAsapMinButtonActive={
            settings.order_confirm_asap_minutes_buttons_is_active
          }
          show={true}
        />
      )}
    </>
  );
};

export default LiveModals;
